export const firebaseConfig = {
  apiKey: "AIzaSyDep3xrzjrGxG3mYH8j0JEB1xLdrgavk4A",
  authDomain: "byba-ac2ed.firebaseapp.com",
  databaseURL: "https://byba-ac2ed.firebaseio.com",
  projectId: "byba-ac2ed",
  storageBucket: "byba-ac2ed.appspot.com",
  messagingSenderId: "291971502691",
  appId: "1:291971502691:web:a60e349b3313a7265e5e56",
  measurementId: "G-VNQNP9FSHH"
};
